import { Box, Divider, Stack } from '@mui/material';
import React from 'react';

import { MobileBody, MobileCaption } from '../Typography';

export interface KeyValueRowItem {
  label: string;
  value: string;
}

export interface KeyValueCardProps {
  /** Filas a mostrar: etiqueta (izq) y valor (der). */
  items: KeyValueRowItem[];
  /** Número de últimas filas con estilo destacado (bold + color primary). Por defecto 1. */
  highlightLastRows?: number;
  sx?: object;
}

const KeyValueCard: React.FC<KeyValueCardProps> = ({
  items,
  highlightLastRows = 1,
  sx,
}) => {
  if (items.length === 0) return null;

  const n = Math.max(0, Math.min(highlightLastRows, items.length));
  const normalItems = n > 0 ? items.slice(0, -n) : items;
  const highlightedItems = n > 0 ? items.slice(-n) : [];

  return (
    <Box
      sx={{
        px: 1.5,
        py: 1.25,
        ...sx,
      }}
    >
      <Stack spacing={1}>
        {normalItems.map((row, index) => (
          <Box
            key={`${row.label}-${index}`}
            sx={{
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 1,
              minWidth: 0,
            }}
          >
            <MobileCaption
              component="span"
              sx={{
                color: 'text.secondary',
                fontSize: '0.75rem',
                fontWeight: 400,
                flex: '1 1 auto',
                minWidth: 0,
              }}
            >
              {row.label}
            </MobileCaption>
            <MobileCaption
              component="span"
              sx={{
                color: 'text.primary',
                fontSize: '0.75rem',
                fontWeight: 600,
                flexShrink: 0,
              }}
            >
              {row.value}
            </MobileCaption>
          </Box>
        ))}
        {highlightedItems.length > 0 && (
          <>
            <Divider sx={{ my: 0.5 }} />
            {highlightedItems.map((row, index) => (
              <Box
                key={`${row.label}-highlight-${index}`}
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  gap: 1,
                  minWidth: 0,
                }}
              >
                <MobileBody
                  component="span"
                  sx={{
                    color: 'text.primary',
                    fontSize: '1rem',
                    fontWeight: 600,
                    flex: '1 1 auto',
                    minWidth: 0,
                  }}
                >
                  {row.label}
                </MobileBody>
                <MobileBody
                  component="span"
                  sx={{
                    color: 'primary.main',
                    fontSize: '1rem',
                    fontWeight: 700,
                    flexShrink: 0,
                  }}
                >
                  {row.value}
                </MobileBody>
              </Box>
            ))}
          </>
        )}
      </Stack>
    </Box>
  );
};

export default KeyValueCard;
